import { render, staticRenderFns } from "./production_report.vue?vue&type=template&id=2284bd9d&scoped=true"
import script from "./production_report.vue?vue&type=script&lang=js"
export * from "./production_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2284bd9d",
  null
  
)

export default component.exports